"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_string_1 = require("../strings/is-string");
function isProperty(key) {
    return is_string_1.isString(key);
}
function getValue(obj, key, transform) {
    if (isProperty(transform.from))
        return obj[transform.from];
    try {
        return transform.from(obj);
    }
    catch ({ message }) {
        throw new Error(`Transform of property '${key}' threw error: ${message}`);
    }
}
exports.getValue = getValue;
/*
 * Remodel the given object to a new schema.
 *
 * @Param {Object} obj              = The object to remodel.
 * @Param {ITransformSchema} schema = The schema to base the remodel on.
 *
 * @Example
 *   remodel({ food: 'Pineapple Pizza' }, { trash: { from: 'food' } })
 *   //=> { trash: 'Pineapple Pizza' }
 *
 *   remodel({ calories: 5000 }, { kiloCalories: o => o.calories / 1000 })
 *   //=> { kiloCalories: 5 }
 */
function remodel(obj, schema) {
    // eslint-disable-next-line max-len
    return Object.entries(schema).reduce((result, [key, transform]) => (Object.assign({}, result, { [key]: getValue(obj, key, transform) })), {});
}
exports.remodel = remodel;
//# sourceMappingURL=remodel.js.map